<template>
  <div class="page-404 page">
    <BreadcrumbsComponent @back.prevent :links="[{ title: 'Ошибка 404' }]" />
    <div class="sides-padding">
      <div class="container">
        <div class="page-404__content">
          <span class="page-404__image">
            <IconComponent name="emoji-sad" />
          </span>
          <span class="page-404__title"> Страница не найдена </span>
          <span class="page-404__subtitle">Возможно она была перенесена или ее не существует</span>
          <div class="page-404__actions">
            <router-link :to="{ name: 'home' }" class="btn btn--md btn--gray">Вернуться на главную</router-link>
            <router-link :to="{ name: 'catalog' }" class="btn btn--md btn--main">Перейти в каталог</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import IconComponent from "components/IconComponent.vue";
import NOT_FOUND_PAGE from "@/graphql/pages/NotFoundPage.graphql";

export default {
  components: { IconComponent, BreadcrumbsComponent },
  async asyncData({ res, apollo, store }) {
    await apollo.defaultClient
      .query({
        query: NOT_FOUND_PAGE,
      })
      .then(({ data }) => {
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        state.marketplace = data.marketplace;
      })
      .catch(() => {});
    if (res) {
      res.status(404);
    }
  },
};
</script>

<style lang="stylus">
.page-404 {
  &__content {
    display flex
    flex-direction column
    align-items center
    gap 15px
    padding 80px 0
    text-align center
    +below(580px) {
      padding 50px 0
    }
    +below(440px) {
      padding 30px 0 0
    }
  }

  &__image {
    display flex
    padding 35px
    border: 1px solid var(--gray)
    border-radius: 50%
    margin-bottom 15px
    +below(580px) {
      margin-bottom: 0;
    }
    +below(440px) {
      padding 20px
    }

    .icon {
      width 80px
      height 80px

      svg path {
        stroke var(--main-color-75)
      }
    }
  }

  &__title {
    font-weight: 700;
    font-size: 1.375em
    line-height: 115%
  }

  &__actions {
    display flex
    flex-wrap wrap
    gap 30px
    +below(580px) {
      flex-direction column
      gap 10px
    }
  }
}
</style>
